import { useState, useEffect } from "react";
import { PlanificationSettings } from "../../../types/instanceTypes";
import {
  updatePlanificationSettings,
  getPlanningConfiguration,
} from "../../../services/instanceService";
import { useTranslation } from 'react-i18next';
import { message } from 'antd';

export const usePlanificationSettings = () => {
  const { t } = useTranslation();
  const [planificationConfig, setPlanificationConfig] =
    useState<PlanificationSettings>({
      days: [],
      timeSlots: [],
    });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchPlanificationSettings();
  }, []);

  const fetchPlanificationSettings = async () => {
    try {
      setLoading(true);
      const settings = await getPlanningConfiguration();
      setPlanificationConfig(settings.data);
      setError(null);
    } catch (err) {
      setError("Failed to fetch planification settings");
      console.error("Error fetching planification settings:", err);
      message.error(t("failed_to_fetch_planification_settings"));
    } finally {
      setLoading(false);
    }
  };

  const savePlanificationSettings = async (settings: {planningConfiguration : PlanificationSettings}) => {
    try {
      setLoading(true);
      const updatedSettings = await updatePlanificationSettings(settings);
      setPlanificationConfig(updatedSettings);
      setError(null);
      message.success(t("planification_settings_updated_successfully"));
      return true;
    } catch (err) {
      setError("Failed to update planification settings");
      console.error("Error updating planification settings:", err);
      message.error(t("failed_to_update_planification_settings"));
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    planificationConfig,
    setPlanificationConfig,
    loading,
    error,
    savePlanificationSettings,
  };
};
